export enum FlowType {
    // Phone -> credit card trial (user has only entered phone before landing on checkout)
    PTCC = 'ptcc',
    // Premium Only
    PREMIUM = 'premium',
    // Dryish Jan
    DRYJAN2024 = 'dryjan2024',
}